import React, { memo, useState } from 'react'
import { Layout } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import Navbar from '../navbar'
import Header from '../header'

const { Content } = Layout;

const MainContainer = (props) => {

  const [collapsed, setCollapsed] = useState(false)

  const toggle = () => setCollapsed(v => !v)

  return (
    <Layout>
        {/* <div style="transform: rotate(30);"></div>
        <div style={{
          transform: 'rotate(30)',
          transformOrigin: '',
          marginTop: '10px',
        }}></div> */}
        <Navbar collapsed={collapsed} />
        {/* <Sider trigger={null} collapsible collapsed={collapsed}>
          <div className="logo" />
          <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
            <Menu.Item key="1" icon={<UserOutlined />}>
              nav 1
            </Menu.Item>
            <Menu.Item key="2" icon={<VideoCameraOutlined />}>
              nav 2
            </Menu.Item>
            <Menu.Item key="3" icon={<UploadOutlined />}>
              nav 3
            </Menu.Item>
          </Menu>
        </Sider> */}
        <Layout className="site-layout">
          {/* <Header collapsed="collapsed" toggle={toggle}/> */}
          <Header collapsed={collapsed} toggle={toggle} />
          {/* <Header className="site-layout-background" style={{ padding: 0 }}>
            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: toggle,
            })}
          </Header> */}
          <Content
            className="site-layout-background"
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
            }}
          >
            {props.children}
          </Content>
        </Layout>
      </Layout>
  )
}

export default memo(MainContainer)